import { CHAT } from "../lib/constants/actions";
export const chat = (state = {}, action) => {
    switch (action.type) {
        case CHAT.GET_ROOMS_SUCCESS:
            return { ...state, rooms: action.payload }
        case CHAT.GET_MESSAGES_SUCCESS:
            console.log('action.payload', action.payload)
            return { ...state, messages: action.payload }
        case CHAT.ACCESS_REQUEST_SUCCESS:
            return { ...state, accessRequestSent: action.payload }
        default:
            return state;
    }
};




